module.exports = __webpack_public_path__ + "media/images/case_studies/bouygues_telecom/creative_diagnosis-1ca7d437e0b433f663950ef992174416.svg";